import { Cliente } from '../shared/entity/Cliente';
import Endereco from '../shared/entity/Endereco';
import api from './api';
import { FindManyReq, FindOneReq } from '../shared/types/TypeormTypes';

const BASE_URL = '/cliente';

class clienteApi {
  // async getOne(params: Partial<Cliente>) {
  //   try {
  //     let res = await api.get<Cliente>(BASE_URL, { params });
  //     let data = res.data;
  //     return data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  async getClienteCompleto(id: number) {
    const clientes = await this.getMany({
      where: { id },
      take: 1,
      relations: ['enderecos']
    });
    if (clientes.length) {
      const retorno = clientes[0];
      if (retorno.enderecos) {
        retorno.enderecos = retorno.enderecos.filter((end) => end.inativo !== true);
      } else {
        retorno.enderecos = [];
      }
      return retorno;
    }
    throw new Error('Cliente não encontrado.');
  }

  async getMany(query: FindManyReq<Cliente>) {
    try {
      let res = await api.post<Cliente[]>(BASE_URL + '/get', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async count(query: FindManyReq<Cliente>) {
    try {
      let res = await api.post<number>(BASE_URL + '/count', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  // async update(where: Partial<Cliente>, update: Partial<Cliente>) {
  //   try {
  //     let res = await api.put(BASE_URL, { update }, { params: where });
  //     let data = res.data;
  //     return data;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  async enviarCodigoSMS(celular: string) {
    try {
      let res = await api.post(BASE_URL + '/enviarCodigoSMS', { celular });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async verificarCodigoSMS(codigo: string) {
    try {
      let res = await api.post(BASE_URL + '/verificarCodigoSMS', { codigo });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async insert(cliente: Partial<Cliente>) {
    try {
      let res = await api.post<Cliente>(BASE_URL, { cliente });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async novoEndereco(endereco: Partial<Endereco>, clienteId: number) {
    try {
      let res = await api.post(BASE_URL + '/novoEndereco', { endereco, clienteId });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async deletarEndereco(enderecoId: number, clienteId: number) {
    try {
      let res = await api.post(BASE_URL + '/deletarEndereco', { enderecoId, clienteId });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async updatePushToken(pushToken: string) {
    try {
      let res = await api.post(BASE_URL + '/pushToken', { pushToken });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async updateCelular(celular: string) {
    try {
      let res = await api.post(BASE_URL + '/updateCelular', { celular });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new clienteApi();
